import { axiosInstance } from "@/services/axios.js";
import { OpenAPIFactory } from "@/services/OpenAPIFactory.ts";

export const openAPIFactory = new OpenAPIFactory(axiosInstance);
